export default __webpack_public_path__ + "68b6390be47e26e174e8fd2656851b60.png";